<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div class="vx-row">

      <!-- CARD 1: CONGRATS -->
      <div class="vx-col w-full lg:w-3/4 mb-base">
        <vx-card slot="no-body" class="my-1  text-center bg-primary-gradient greet-user">
          <img src="@/assets/images/elements/decore-left.png" class="decore-left" alt="Decore Left" width="200" >
          <img src="@/assets/images/elements/decore-right.png" class="decore-right" alt="Decore Right" width="175">
          <feather-icon style="background-color: #2d2d3c;" icon="AwardIcon" class="p-6 mb-8 inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon>
          <h1 class="mb-6 text-white">Welcome back {{ activeUserInfo.name }} {{ activeUserInfo.last_name}},</h1>
          <!-- <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">You have done </p> -->
        </vx-card>
      </div>

      <!-- CARD 2: SUBSCRIBERS GAINED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line
          hideChart
          class=" mb-2 "
          icon="UsersIcon"
          icon-right
          :statistic="studentsCount"
          statisticTitle="Students"
          color="danger" />
      </div>
    </div>


    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vx-card title="">
          <vue-apex-charts ref="mixedChart" type="area" height="350" :options="mixedChart.chartOptions" :series="mixedChart.series"></vue-apex-charts>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
import moduleClassManagement from '@/store/class-management/moduleClassManagement.js'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import VueApexCharts from 'vue-apexcharts'
import apexChatData from './apexChartData.js'

export default {
  data() {
    return {
      apexChatData: apexChatData,
      recentClasses: [],
      studentsCount : 0,
      teachersCount : 0,
      activeUserInfo : JSON.parse(localStorage.getItem("userInfo")),
      dateRangeData : [],
      studentCountData : [],
      recentClassesCount: {
        series: [],
        chartOptions: {
          colors: ['#00A99D', '#A7006D', '#EA5455', '#FF9F43', '#1E1E1E'],
          chart: {
            stacked: false,
          },
          stroke: {
            width: [2, 2],
            curve: 'smooth'
          },
          plotOptions: {
            bar: {
              columnWidth: '50%'
            }
          },

          fill: {
            opacity: [1, 1, 1],
            gradient: {
              inverseColors: false,
              shade: 'light',
              type: "vertical",
              opacityFrom: 0.85,
              opacityTo: 0.55,
              stops: [0, 100, 100, 100]
            }
          },
          labels: [],
          markers: {
            size: 0
          },
          xaxis: {
            tooltip: {
              enabled: false
            },
            type: 'datetime',
            // labels: {
            //  format: 'MM yyyy'
            // }
          },
          yaxis: {
            tooltip: {
              enabled: false
            },
            title: {
                text: 'Number of completed classes last 30 days',
            },
            min: 0
          },
          tooltip: {
            enabled: false
          },
        }
      },
      mixedChart: {
        series: [],
        chartOptions: {
          colors: ['#00A99D', '#A7006D', '#EA5455', '#FF9F43', '#1E1E1E'],
          chart: {
            stacked: false,
          },
          stroke: {
            width: [2, 2],
            curve: 'smooth'
          },
          plotOptions: {
            bar: {
              columnWidth: '50%'
            }
          },

          fill: {
            opacity: [1, 1, 1],
            gradient: {
              inverseColors: false,
              shade: 'light',
              type: "vertical",
              opacityFrom: 0.85,
              opacityTo: 0.55,
              stops: [0, 100, 100, 100]
            }
          },
          labels: [],
          markers: {
            size: 0
          },
          xaxis: {
            type: 'datetime',
            tooltip: {
              format: 'MM yyyy'
            },
            // labels: {
            //  format: 'MM yyyy'
            // }
          },
          yaxis: {
            title: {
              text: 'Number of users signup',
            },
            min: 0
          },
          tooltip: {
            shared: true,
            intersect: false,
          }
        }
      },
      barChart: {
        series: [],
        chartOptions: {
          colors: ['#00A99D', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
          plotOptions: {
            bar: {
              horizontal: true,
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
          },
        }
      },
      pieChart: {
        series: [0, 0, 0, 0, 0, 0, 0],
        series: [],
        chartOptions: {
          labels: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
          // colors: ['#A7006D', '#0086A7', '#2BDD43', '#C1AF00', '#E1331F', '#F1CD64', '#0C36B8'],
          // responsive: [{
          //   breakpoint: 480,
          //   options: {
          //     chart: {
          //       width: 200
          //     },
          //     legend: {
          //       position: 'bottom'
          //     }
          //   }
          // }],
          dataLabels: {
            enabled: true
          },
          plotOptions: {
            pie: {
              size: 200
            }
          }
        }
      },
 

    }
  },
  components: {
    StatisticsCardLine,
    VueApexCharts
  },
  computed: {
    studentsRegistationY(){
      return [{ name: 'Students', data : this.$store.state.userManagement.studentsRegistationY }]
    },
    studentsRegistationX(){
      return {
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        colors: ['#2bdac7', '#2bdac7', '#2bdac7', '#2bdac7', '#2bdac7'],
        xaxis: {
          type: 'datetime',
          categories: this.$store.state.userManagement.studentsRegistationX,
        },
        
      }
    },
  },
  async created() {
    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    if(!moduleClassManagement.isRegistered) {
      this.$store.registerModule('classManagement', moduleClassManagement)
      moduleClassManagement.isRegistered = true
    }

    this.teachersCount = this.$store.state.userManagement.teachersCount
    this.studentsCount = this.$store.state.userManagement.studentsCount
    this.recentClasses = this.$store.state.classManagement.recentClasses

    var data = this.$store.state.userManagement.students,
      result = await data.reduce((r, { created_at }) => {
        var key = created_at.slice(0, 7);
        r[key] = (r[key] || 0) + 1;
        return r;
      }, {});

    var labelsArray = [];
    var valuesStudentsArray = [];
    var valuesTeachersArray = [];

    for (var i in result) {
      valuesStudentsArray.push(result[i])
      labelsArray.push(i)
    }

    this.$refs.mixedChart.updateOptions({
      labels : labelsArray
    });



    this.$refs.mixedChart.updateSeries([{
      name: 'Students',
      type: 'area',
      data: valuesStudentsArray
    }]);





    await this.$store.dispatch("userManagement/fetchStudents")
      .then(res => { 
        this.studentsCount = res.data.length
      })

     var data = this.$store.state.userManagement.students,
        result = await data.reduce((r, { created_at }) => {
          var key = created_at.slice(0, 7);
          r[key] = (r[key] || 0) + 1;
          return r;
        }, {});

      var labelsArray = [];
      var valuesStudentsArray = [];
      var valuesTeachersArray = [];

 


      for (var i in result) {
        valuesStudentsArray.push(result[i])
        labelsArray.push(i)
      }

      this.$refs.mixedChart.updateOptions({
        labels : labelsArray
      });

      // for (var i in result) {
      //   valuesTeachersArray.push(result[i])
      // }

      this.$refs.mixedChart.updateSeries([{
        name: 'Students',
        type: 'area',
        data: valuesStudentsArray
      }]);

    /////////////////////////////////////////////



  },
  mounted(){

  },
  methods: {
    redirectToStudent(tr) {
      this.$router.push("/students/" + tr['id']).catch(() => {})
    },
    redirectToTeacher(tr) {
      this.$router.push("/teachers/" + tr['id']).catch(() => {})
    },
    getSignDate(tr) {
      return (tr['signed_date']) ? tr['signed_date'] : '-'
    },
    getFullName(tr) {
      let firstName = (tr['name']) ? tr['name'] : ''
      let lastName = (tr['last_name']) ? tr['last_name'] : ''
      return firstName+' '+lastName
    },
    getteacherSignColor(tr) {
      if(tr['teacher_sign'] == '1') return 'bg-success'
      else return 'bg-danger'
    },
    getstudentSignColor(tr) {
      if(tr['student_sign'] == '1') return 'bg-success'
      else return 'bg-danger'
    },
    refreshRecentClasses(card) {
      this.$store.dispatch("classManagement/fetchRecentClasses")
      .then(res => { 
        this.recentClasses = res.data
        card.removeRefreshAnimation();
      })
      .catch(err => { 
        card.removeRefreshAnimation();
      })
    }
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>

